<template>
  <div
    class="icon-button"
    :class="{
      'key-takeaway': variant === 'key-takeaway',
    }"
    @click="$emit('click')"
  >
    <slot name="icon">
      <icon
        v-if="iconName"
        :name="iconName"
        :variant="iconVariant"
        class="icon"
      ></icon>
    </slot>
    <span
      class="label-text"
    >
      <span
        v-html="changeRootPTagToSpan(labelHtml)"
      ></span>
      <slot name="metadata"></slot>
    </span>
    <slot></slot>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import { changeRootPTagToSpan } from '@/utils';

export default {
  components: {
    Icon,
  },
  props: {
    labelHtml: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    iconVariant() {
      if (this.variant === 'key-takeaway') {
        return '326ff0';
      }
      return '697586';
    },
  },
  methods: {
    changeRootPTagToSpan,
  },
};
</script>

<style lang="scss" scoped>
.icon-button {
  border: 1px solid transparent;
  border-radius: rem-calc(6);
  color: #697586;
  cursor: pointer;
  display: grid;
  gap: rem-calc(8);
  grid-template-columns: rem-calc(24) 1fr;
  margin: 0;
  padding: 0.5rem;

  .icon {
    justify-self: center;
    margin-top: 2px;
  }

  .label-text {
    grid-column-start: 2;
    grid-column-end: 3;
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 24px;
  }
}
</style>
